import script from "./PgsInputFill.vue?vue&type=script&setup=true&lang=ts"
export * from "./PgsInputFill.vue?vue&type=script&setup=true&lang=ts"

import "./PgsInputFill.vue?vue&type=style&index=0&id=07708e2e&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07708e2e"]])

export default __exports__